import React, { useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  Modal,
  Image,
  TouchableOpacity,
  ActivityIndicator,
  Platform,
} from "react-native";
import { useNavigation, StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import OTPTextView from "react-native-otp-textinput";
import { toast } from "react-toastify";
import ModalContainer from "./sign-up-common-components/ModalContainer";
import BackgroundImage from "./sign-up-common-components/BackGroundImage";
import * as Clipboard from 'expo-clipboard';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { base_url, endpoints, urls, dynamicWebUrl } from "../../../Api/configs";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import { AppImages } from "../../../utility/AppImages";
import { AppScreens } from "../../Utility/AppScreens";
import {
  login,
  resendVerificationCode,
  verifyUser,
} from "../../../services/authAPI";
import { storeLoginData } from "../../../utility/AppStoreData";

interface EmailVerificationModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  username: string;
  setSignUpShowModel: (showModel: boolean) => void;
  path: string;
  authType?: 'email' | 'phone';
}

const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({
  showModal,
  setShowModal,
  username,
  setSignUpShowModel,
  path,
  authType = 'email',
}) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [otpInput, setOtpInput] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const otpRef = useRef<any>(null);

  // Dynamic title based on auth type
  const verificationTitle = authType === 'phone' ? 'WhatsApp Verification' : 'Email Confirmation';

  useEffect(() => {
    const handlePaste = async (event: any) => {
      try {
        let text;
        // Use navigator.clipboard for web, expo-clipboard for mobile
        if (typeof navigator !== "undefined" && navigator.clipboard) {
          text = await navigator.clipboard.readText();
        } else {
          text = await Clipboard.getStringAsync();
        }

        if (text && /^\d{6}$/.test(text)) {
          setOtpInput(text);
          if (otpRef.current) {
            otpRef.current.setValue(text);
          }
        }
      } catch (error) {
        console.log('Paste error:', error);
      }
    };

    // Add paste event listener for web
    if (typeof window !== "undefined") {
      window.addEventListener("paste", handlePaste);
      return () => {
        window.removeEventListener("paste", handlePaste);
      };
    };
  }, []);

  const pasteFromClipboard = async () => {
    try {
      const text = await Clipboard.getStringAsync();
      if (text && /^\d{6}$/.test(text)) {
        setOtpInput(text);
        if (otpRef.current) {
          otpRef.current.setValue(text);
        }
      } else if (text && /^\d+$/.test(text.substring(0, 6))) {
        // If user copied more than 6 digits, take first 6
        const otpCode = text.substring(0, 6);
        setOtpInput(otpCode);
        if (otpRef.current) {
          otpRef.current.setValue(otpCode);
        }
      }
    } catch (error) {
      console.log('Paste from clipboard error:', error);
    }
  };

  const onCloseClick = () => {
    setShowModal(false);
    setSignUpShowModel(false);
  };
  const loginAPI = async () => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2)
        return decodeURIComponent(parts.pop().split(";").shift());
      return null;
    };
    const password = getCookie("password");
    const params = {
      username: username,
      password: password,
    };
    const data = await login(params);
    if (data.statusCode === 200) {
      storeLoginData(data.body);
    }
  };

  const userVerifyAPI = async () => {
    if (otpInput.length !== 6) {
      toast.error("Please enter a valid OTP");
      return;
    }

    setShowLoader(true);

    const bodyParams = {
      username,
      confirmationCode: otpInput,
    };

    try {
      const data = await verifyUser(bodyParams);

      if (data.statusCode === 200 || data.statusCode === 201) {
        const responseBody =
          typeof data.body === "string" ? JSON.parse(data.body) : data.body;
        toast.success("Email verification successful");
        await loginAPI();
        if (path) {
          window.location.href = `${dynamicWebUrl}${path}`;
          setShowLoader(false);
        } else {
          navigateToScreen(navigation, AppScreens.DrawerRoute, {
            username: username,
          });
          setShowLoader(false);
        }
        onCloseClick();
      } else {
        const responseBody =
          typeof data.body === "string" ? JSON.parse(data.body) : data.body;
        toast.error(responseBody.message || "Verification Failed");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };
  const resendCode = async (username: string) => {
    try {
      setShowLoader(true);

      const data = await resendVerificationCode(username);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      setShowLoader(false);

      if (data.statusCode === 200 || data.statusCode === 201) {
        toast.success(
          responseBody.message || "Verification code sent successfully"
        );
      } else {
        toast.error(responseBody.error || "Resend Failed");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  return (
    <View>
      <Modal
        animationType="fade"
        transparent={true}
        visible={showModal}
        onRequestClose={onCloseClick}
      >
        <ModalContainer>
          <BackgroundImage deviceSize={deviceSize} styles={styles} />
          <View
            style={[
              {
                // paddingHorizontal: "5%",
                // paddingVertical: "6%",
                paddingHorizontal: "5%",
                // paddingVertical: deviceSize === DEVICE_SIZES.XS ? "20%" : "6%",
                paddingTop: deviceSize === DEVICE_SIZES.XS ? "20%" : "3%",
                paddingBottom: deviceSize === DEVICE_SIZES.XS ? "20%" : "6%",
              },
              styles.bgImageWidth,
            ]}
          >
            <Image source={AppImages.icMainLogo} style={styles.appLogoStyle} />
            <Text
              style={[
                DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_24
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  color: AppColors.white,
                },
              ]}
            >
              {verificationTitle}
            </Text>

            <OTPTextView
              ref={otpRef}
              handleTextChange={setOtpInput}
              offTintColor={AppColors.appBlueColor_3A5175}
              tintColor={AppColors.themeColor_0A89AD}
              containerStyle={styles.textInputContainer}
              textInputStyle={styles.roundedTextInput}
              inputCount={6}
              inputCellLength={1}
              keyboardType="numeric"
            />

            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                marginVertical: 10,
              }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  {
                    color: "white",
                  },
                ]}
              >
                Didn't get the code?{" "}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  resendCode(username);
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    {
                      color: "white",
                    },
                  ]}
                >
                  {" "}
                  Resend code{" "}
                </Text>
              </TouchableOpacity>
            </View>

            {/* Paste from Clipboard Button - Mobile Only */}
            {Platform.OS !== 'web' && (
              <TouchableOpacity
                onPress={pasteFromClipboard}
                style={{
                  marginBottom: 10,
                  alignSelf: 'center',
                }}
              >
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    {
                      color: AppColors.themeColor_0A89AD,
                      textDecorationLine: 'underline',
                    },
                  ]}
                >
                  Paste from clipboard
                </Text>
              </TouchableOpacity>
            )}

            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: AppColors.themeColor_0A89AD,
                borderRadius: 32,
                marginTop: 10,
                paddingVertical: 16,
                marginHorizontal: "20%",
              }}
              onPress={userVerifyAPI}
              disabled={showLoader}
            >
              {showLoader ? (
                <ActivityIndicator color={AppColors.white} />
              ) : (
                <Text style={[AppFontStyle.BOLD_ANYBODY_14]}>Confirm</Text>
              )}
            </TouchableOpacity>
          </View>
        </ModalContainer>
      </Modal>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    appLogoStyle: {
      alignSelf: "center",
      height: "30%",
      width: "40%",
      // marginTop: "6%",
      marginBottom: "8%",
      resizeMode: "contain",
    },
    textInputContainer: {
      marginTop: 25,
      height: 60,
    },
    roundedTextInput: {
      borderRadius: 14,
      borderWidth: 1,
      borderBottomWidth: 1,
      alignContent: "center",
      backgroundColor: AppColors.appBlueColor_3A5175,
      fontSize: 16,
      color: AppColors.white,
      shadowColor: AppColors.bgBlueColor_1B0D38,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.2,
      shadowRadius: 2,
      elevation: 2,
      width: 60,
      height: 60,
    },
    bgImageWidth: {
      width: "40%",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      bgImageWidth: {
        width: "55%",
      },
    },
    [DEVICE_SIZES.MD]: {
      bgImageWidth: {
        width: "65%",
      },
    },
    [DEVICE_SIZES.SM]: {
      roundedTextInput: {
        borderRadius: 14,
        borderWidth: 1,
        borderBottomWidth: 1,
        alignContent: "center",
        backgroundColor: AppColors.appBlueColor_3A5175,
        fontSize: 16,
        color: AppColors.white,
        shadowColor: AppColors.bgBlueColor_1B0D38,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
        width: 50,
        height: 50,
      },
      bgImageWidth: {
        width: "65%",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      appLogoStyle: {
        alignSelf: "center",
        height: "25%",
        width: "40%",
        // marginTop: "8%",
        resizeMode: "contain",
      },
      textInputContainer: {
        marginTop: 25,
        height: 60,
      },
      roundedTextInput: {
        borderRadius: 14,
        borderWidth: 1,
        borderBottomWidth: 1,
        alignContent: "center",
        backgroundColor: AppColors.appBlueColor_3A5175,
        fontSize: 16,
        color: AppColors.white,
        shadowColor: AppColors.bgBlueColor_1B0D38,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        elevation: 2,
        width: 36,
        height: 40,
      },
      bgImageWidth: {
        width: "95%",
      },
    },
  }
);

export default EmailVerificationModal;
